import React from "react";
import { UploadDocComponent, ModalTemplate } from "../../reusableComponent";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
  uploadProjectIssuesAction,
  clearUploadProjectIssuesAction
} from "../../../actions/dowloadExcelActions";
import { toast } from "react-toastify";
import { FormDataForImage, isValidArray } from "../../../helper";
import { successToastStyle, errorToastStyle } from "../../../customToast";
import { UploadProjectIssuesModal } from "../modal/uploadProjectIssuesModal";
class UploadProjectsIssues extends React.PureComponent {
  state = {
    toggleUploadPopUp: false,
    listofFiles: [],
    showUploadResultModal: false
  };

  // upload files
  onUploadFile = e => {
    try {
      const { files } = e.target;
      const filesArr = [];
      // only on file can upload
      if (files.length > 1) {
        toast.error(
          <p className="toast-text-alignment">Only one file can be uploaded</p>,
          errorToastStyle
        );
        return false;
      }
      // extract the files
      for (let index = 0; index < files.length; index++) {
        const file = files[index];
        if (
          //file.type !== 'text/csv' &&
          //file.type !== 'application/vnd.ms-excel' &&
          file.type !==
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        ) {
          toast.error(
            <p className="toast-text-alignment">Invalid File Type</p>,
            errorToastStyle
          );
          return false;
        }

        // Validate file size (max 5MB)
        const maxSize = 5 * 1024 * 1024; // 5MB in bytes
        if (file.size > maxSize) {
          toast.error(
            <p className="toast-text-alignment">
              File exceeds the maximum size limit of 5 MB
            </p>,
            errorToastStyle
          );
          return false;
        }
        filesArr.push(file);
      }
      this.setState({
        listofFiles: filesArr
      });
    } catch (error) {
      console.error(error);
    }
  };

  // on submit upload files
  onSubmitFile = async () => {
    const {
      uploadProjectIssuesAction,
      uploadedProjectissues,
      onUploadToggle
    } = this.props;
    console.log("uploadedProjectissues", uploadedProjectissues);
    try {
      const { listofFiles } = this.state;
      if (isValidArray(listofFiles)) {
        let formData = FormDataForImage(listofFiles, "file");
        const existingProjectIds = uploadedProjectissues.map(
          project => project.id
        );
        const existingIssueIds = uploadedProjectissues.flatMap(project =>
          (project.issuesSelected || []).map(issue => issue.id)
        );

        if (existingProjectIds && existingProjectIds.length > 0) {
          formData.append("existingProjectIds", existingProjectIds.join(","));
        }
        if (existingIssueIds && existingIssueIds.length > 0) {
          formData.append("existingIssueIds", existingIssueIds.join(","));
        }

        const response = await uploadProjectIssuesAction(formData);
        console.log("response", response);

        if (response && response.status) {
          if (response.data.errorStatus) {
            const hasValidProjects =
              response &&
              response.data &&
              Array.isArray(response.data.projectsData) &&
              response.data.projectsData.length > 0;

            console.log("hasValidProjects", hasValidProjects);
            if (hasValidProjects) {
              this.setState({
                toggleUploadPopUp: false,
                listofFiles: []
              });
              console.log("onUploadToggle");
              onUploadToggle();
            }
          } else {
            toast.error(
              <p className="toast-text-alignment">{response.data.message}</p>,
              errorToastStyle
            );
          }
        }
      } else {
        // if not file is attached
        toast.error(
          <p className="toast-text-alignment">
            No file is for uploading. Please attach a file.
          </p>,
          errorToastStyle
        );
      }
    } catch (error) {
      this.setState({ toggleUploadPopUp: false, listofFiles: [] });
      onUploadToggle();
      console.log(error);
    }
  };

  closeUploadedListModal = () => {
    this.setState({ showUploadResultModal: false });
  };

  render() {
    console.log("hello, in upload ProjectIssues component");
    const {
      state: { listofFiles },
      props: {
        uploadProjectIssuesReducer,
        onUploadToggle,
        isCustom,
        customSection
      },
      onSubmitFile,
      onUploadFile
    } = this;

    return (
      <>
        <UploadProjectIssuesModal
          centered
          isLoading={uploadProjectIssuesReducer.isLoading}
          containerClass="download-upload-popup"
          onClose={onUploadToggle}
          template={
            <ModalTemplate
              isCustom={isCustom}
              customSection={customSection}
              onClose={onUploadToggle}
              onSubmit={onSubmitFile}
              onSubmitTitle="Upload"
              onCloseTitle="Close"
              headerTitle="Upload File"
              submitDisable={!(isValidArray(listofFiles) && listofFiles.length)}
              bodyTemplate={
                <>
                  <UploadDocComponent
                    filesName={listofFiles.map(value => value.name).toString()}
                    feedback="* .xlsx file upto 5MB"
                    extensions=".xlsx"
                    onUpload={onUploadFile}
                  />
                  {isValidArray(listofFiles) ? (
                    <>
                      <div className="upload-project-issues-browse-body">
                        <div className="title">File Name: </div>
                        {listofFiles.map(value => (
                          <div key={value.name} className="uploded-image-names">
                            {value.name}
                          </div>
                        ))}
                      </div>
                    </>
                  ) : null}
                </>
              }
            />
          }
        />
      </>
    );
  }
}

function mapStateToProps(state) {
  return {
    uploadProjectIssuesReducer: state.donwloadExcelReducer.uploadProjectIssues,
    uploadedList: state.donwloadExcelReducer.uploadProjectIssues.uploadedList
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      uploadProjectIssuesAction,
      clearUploadProjectIssuesAction
    },
    dispatch
  );
}

const UploadProjectsIssuesComponent = connect(
  mapStateToProps,
  mapDispatchToProps
)(UploadProjectsIssues);
export { UploadProjectsIssuesComponent };
